import { t05ProductIconSrc } from './t05FooterProducts';

export type T05StackPanelVariant = 'rows' | 'chat';

export type T05StackChatMock = {
  userQuestion: string;
  arkoRef?: string;
  arkoAnswer: string;
  badge: string;
  contextLabel?: string;
  contextBadge?: string;
};

export type T05ProductStackSection = {
  id: string;
  num: string;
  mono: string;
  title: string;
  description: string;
  detail: string;
  highlights: string[];
  iconFile: string;
  href: string;
  accent: string;
  panelVariant?: T05StackPanelVariant;
  panelTitle: string;
  panelRows: { label: string; badge: string }[];
  chatMock?: T05StackChatMock;
};

/** 7 Sub-Produkte — erweitert mit Detailtext, Highlights und v3-Icons */
export const T05_PRODUCT_STACK_SECTIONS: T05ProductStackSection[] = [
  {
    id: 'orbis',
    num: '01',
    mono: 'OR',
    title: 'Orbis — All-in-One-Plattform',
    accent: '#405bff',
    iconFile: 'icon-orbis.jpg',
    description:
      'Die All-in-One-Plattform für Kanzleien — Self-Hosted, ein Login, Umfang nach Ihrer Kanzleigröße.',
    detail:
      'Orbis bündelt Diktat, Akte und ARKO unter einem Vertrag. Sitze und Module werden nach Kanzleigröße entschieden.',
    highlights: [
      'All-in-One statt Tarifkarten',
      'Sitze und Module nach Kanzleigröße',
      'Kein US-Cloud-Zwang, volle Datenhoheit',
      'Keine ungenutzten Tools, die man nicht braucht',
    ],
    href: '/produkt/orbis',
    panelTitle: 'orbis://angebot',
    panelRows: [
      { label: 'Individuelles Angebot', badge: 'Gespräch' },
      { label: 'Betrieb bei ARKORBIT', badge: 'Dedizierter Server' },
      { label: 'Server der Kanzlei', badge: 'Kein Standardverkauf' },
    ],
  },
  {
    id: 'arko',
    num: '02',
    mono: 'AR',
    title: 'ARKO — KI-Rechtsassistent',
    accent: '#5b9dff',
    iconFile: 'icon-arko.jpg',
    description:
      'Chat mit Mandatskontext und quellenbelegten Antworten aus LEXCORE — lokal auf Ihrem Server, kein US-Cloud-Export.',
    detail:
      'ARKO antwortet mit Belegen aus dem österreichischen Rechtskern und Ihrer Akte. Hub-Modi für Recherche, Strukturieren und Entwurf — jede Aussage nachvollziehbar, kein Blackbox-Chat.',
    highlights: [
      'Recherche mit LEXCORE-, RIS- und OGH-Quellen',
      'Mandatskontext aus Ihrer Akte und Ihren Dokumenten',
      'Läuft lokal auf Ihrem Server — keine Mandantendaten in die US-Cloud',
    ],
    href: '/produkt/arko',
    panelVariant: 'chat',
    panelTitle: 'arko://session/recherche',
    panelRows: [],
    chatMock: {
      userQuestion: 'Welche Verjährungsfrist gilt für Schadenersatz nach § 1489 ABGB?',
      arkoRef: '§ 1489 ABGB',
      arkoAnswer: 'Drei Jahre ab Kenntnis.',
      badge: 'LEXCORE · RIS',
      contextLabel: 'Aktenkontext: Mandat Müller / Schadenersatz',
      contextBadge: 'Edge',
    },
  },
  {
    id: 'dokumente',
    num: '03',
    mono: 'DK',
    title: 'Dokumente & Akten',
    accent: '#ff9f43',
    iconFile: 'icon-dokumente.jpg',
    description:
      'Alles an den Orten, wo Sie es brauchen — ob Mandantenordner oder ganze Akte, mit klaren Rechten. Kein Tool-Chaos mehr.',
    detail:
      'Schriftsätze und Akten, die Ihnen gehören — eine Oberfläche, klare Zugriffsrechte pro Rolle.',
    highlights: [
      'Schriftsätze und Verträge in einer Oberfläche',
      'Mandantenablage mit klaren Ordnerrechten',
      'Strukturierte Aktenübersicht statt Tool-Chaos',
    ],
    href: '/produkt/dokumente',
    panelTitle: 'orbis://mandant/akte',
    panelRows: [
      { label: 'Schriftsatz_Einrede.docx', badge: 'Bearbeitung' },
      { label: 'Mandantenmappe_2026/', badge: 'Ablage' },
      { label: 'Vermerk_Diktat.pdf', badge: 'Akte' },
    ],
  },
  {
    id: 'litigation',
    num: '04',
    mono: 'LE',
    title: 'Litigation Engine',
    accent: '#f472b6',
    iconFile: 'icon-litigation.jpg',
    description:
      'Gegnerischen Schriftsatz hochladen. Sie erhalten eine strukturierte Auswertung und einen Strategie-Entwurf als PDF — Modul nach Angebot, mit Schutz für sensible Passagen.',
    detail:
      'Die Litigation Engine liest den gegnerischen Schriftsatz und bereitet auf, was für Ihre nächste Antwort zählt. Sensible Stellen können Sie vor der Auswertung abdecken.',
    highlights: [
      'Hochladen, auswerten, Strategie-PDF',
      'Modul nach individuellem Angebot',
      'Sensible Passagen optional abdecken',
    ],
    href: '/produkt/litigation-engine',
    panelTitle: 'litigation://analyse',
    panelRows: [
      { label: 'Gegner_Schriftsatz.pdf', badge: 'Upload' },
      { label: 'Strategie-Entwurf', badge: 'Analyse' },
      { label: 'Pseudonymisiert', badge: 'Opt-In' },
    ],
  },
  {
    id: 'lexcore',
    num: '05',
    mono: 'LC',
    title: 'LEXCORE & BRAIN',
    accent: '#3dd6f5',
    iconFile: 'icon-lexcore.jpg',
    description:
      'Kuratierter österreichischer Rechtskern — Normen und Judikatur — plus kanzlei-eigenes Wissen. Jede Aussage mit Beleg, kein Halluzinations-Blackbox.',
    detail:
      'LEXCORE liefert den zentralen Normenbestand inklusive Judikatur mit RIS-Belegen. BRAIN ergänzt kanzlei-eigenes Wissen — getrennt, nachvollziehbar, für ARKO abrufbar.',
    highlights: [
      'Kuratierte Normen und Judikatur mit RIS-Verweis',
      'Kanzlei-Wissen in BRAIN — mandantenscharf',
      'Zentral bei ARKORBIT, Abruf am Edge',
    ],
    href: '/produkt/lexcore',
    panelTitle: 'lexcore://ris-kern',
    panelRows: [
      { label: 'MRG § 23 — Kündigung', badge: 'RIS' },
      { label: 'ABGB § 1295', badge: 'Kuratiert' },
      { label: 'Kanzlei-Wissen', badge: 'BRAIN' },
    ],
  },
  {
    id: 'diktat',
    num: '06',
    mono: 'DI',
    title: 'Diktat & Transkription',
    accent: '#a78bfa',
    iconFile: 'icon-diktat.jpg',
    description:
      'Sprechen Sie einen Vermerk ein — auf Ihrem Server wird daraus ein Aktenvermerk als PDF. Die Audiodaten verlassen Ihre Umgebung nicht.',
    detail:
      'Diktat per Nachricht oder Upload. Transkription und Zusammenfassung laufen lokal. Der fertige Vermerk landet direkt in der Akte — ohne Cloud-Export.',
    highlights: [
      'Sprache wird lokal in Text verwandelt',
      'Vermerk wird strukturiert, nicht nur abgeschrieben',
      'PDF direkt in die Akte, ohne Cloud-Export',
    ],
    href: '/produkt/diktat',
    panelTitle: 'diktat://pipeline',
    panelRows: [
      { label: 'Audio-Aufnahme', badge: 'Eingang' },
      { label: 'Transkription', badge: 'Lokal' },
      { label: 'PDF-Vermerk', badge: 'Akte' },
    ],
  },
  {
    id: 'portal',
    num: '07',
    mono: 'PO',
    title: 'Kanzlei-Portal',
    accent: '#34d399',
    iconFile: 'icon-portal.jpg',
    description:
      'Ein Web-Zugang zu allen Orbis-Diensten — Dashboard, Mandatsübersicht, Sitzverwaltung, ein Login für die ganze Kanzlei.',
    detail:
      'Das Kanzlei-Portal ist der zentrale Einstieg: Mandatsübersicht, ARKO, Akte, Diktat und Workflows — ein Login, klare Rollen, Sitzverwaltung inklusive.',
    highlights: [
      'Dashboard mit Live-Mandatsübersicht',
      'ARKO, Akte und Diktat in einer Shell',
      'Sitze nach Kanzleigröße',
    ],
    href: '/produkt/portal',
    panelTitle: 'portal://dashboard',
    panelRows: [
      { label: 'Mandatsübersicht', badge: 'Live' },
      { label: 'ARKO · Akte · Diktat', badge: 'Ein Login' },
      { label: 'Sitze nach Angebot', badge: 'Gespräch' },
    ],
  },
];

export function t05StackIconSrc(iconFile: string): string {
  return t05ProductIconSrc(iconFile);
}
